import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function EditModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    editDateValues,        
    setEditDateValues, 
    onUpdate,  
    item,
    loader,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit, setValue } = methods;
    return (
        <>
            <Modal isOpen={isOpen}  toggle={onClose} centered size="lg">
                <div className="modal-header" style={{padding: '30px', border: 'none'}}>
                    <h5 className="modal-title_u">Edit Date</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                    ></button>
                </div>
                <div className="modal-body" style={{padding: '30px', paddingBottom: '0'}}>
                    <div className="mb-3">
                        <div class="row-primary m-0 mb-5">
                        <h2 style={{minWidth: '60px'}}>Start</h2>
                            <input
                                type="date"
                                className="input-in type_inp"
                                value={editDateValues.start}
                                onChange={(e) =>
                                    setEditDateValues({ ...editDateValues, start: e.target.value })
                                }
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                            <div class="row-primary m-0">
                        <h2 style={{minWidth: '60px'}}>End</h2>
                            <input
                                type="date"
                                className="input-in type_inp"
                                value={editDateValues.end}
                                onChange={(e) =>
                                    setEditDateValues({ ...editDateValues, end: e.target.value })
                                }
                            />
                            </div>
                        </div>
                </div>
                <div className='modal-footer' style={{padding: '30px', border: 'none'}}>
                    <button className='Cancle_button' onClick={onClose}>Cancel</button>
                    <button className='main_button'onClick={onUpdate}>Update</button>
                </div>
            </Modal>
        </>
    );
}

export default EditModal;